if (!customElements.get('tw-ct-purchase-cards')) {
  customElements.define(
    'tw-ct-purchase-cards',
    class TwCtPurchaseCards extends HTMLElement {
      connectedCallback() {
        this.formId = this.dataset.formId;
        this.purchaseType = 'subscription';

        this.onCardChange = this.onCardChange.bind(this);
        this.onVariantInputChange = this.onVariantInputChange.bind(this);
        this.onSealWidgetCreated = this.onSealWidgetCreated.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);

        this.addEventListener('change', this.onCardChange);
        document.addEventListener('change', this.onVariantInputChange);
        // Seal re-renders its widget on variant change: re-apply the active card afterwards.
        document.addEventListener('sealsubs:subscription_widget_created', this.onSealWidgetCreated);
        // Capture phase: runs before Dawn's product-form submit handler sends /cart/add.
        document.addEventListener('submit', this.onFormSubmit, true);

        const variantInput = this.getVariantInput();
        this.showVariant(variantInput ? variantInput.value : null);
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.onVariantInputChange);
        document.removeEventListener('sealsubs:subscription_widget_created', this.onSealWidgetCreated);
        document.removeEventListener('submit', this.onFormSubmit, true);
      }

      getForm() {
        return document.getElementById(this.formId);
      }

      getVariantInput() {
        const form = this.getForm();
        return form ? form.querySelector('input[name="id"]') : null;
      }

      onVariantInputChange(event) {
        const target = event.target;
        // getAttribute: form.id would return the form's <input name="id"> instead of its id attribute.
        if (!target.matches('input[name="id"]') || !target.form || target.form.getAttribute('id') !== this.formId) return;

        this.showVariant(target.value);
      }

      showVariant(variantId) {
        let activeGroup = null;

        this.querySelectorAll('.tw-ct-cards__group').forEach((group) => {
          const isActive = group.dataset.variantId === String(variantId);
          group.hidden = !isActive;
          if (isActive) activeGroup = group;
        });

        if (!activeGroup) return;

        // On every variant change the annual subscription becomes the active card.
        const radio =
          activeGroup.querySelector('[data-purchase-type="subscription"]') ||
          activeGroup.querySelector('[data-purchase-type="one_time"]');

        if (!radio) return;

        radio.checked = true;
        this.setSelection(radio);
        this.syncSeal();
      }

      onCardChange(event) {
        const radio = event.target;
        if (!radio.matches('.tw-ct-card__radio')) return;

        // Keep the event out of other theme listeners (e.g. seal-subscription-custom.js).
        event.stopPropagation();
        this.setSelection(radio);
        this.syncSeal();
      }

      setSelection(radio) {
        this.purchaseType = radio.dataset.purchaseType;
        // Subscription radios carry the variant's selling plan id as value.
        this.sellingPlanId = radio.value;
      }

      onSealWidgetCreated() {
        this.syncSeal();
      }

      onFormSubmit(event) {
        if (event.target.getAttribute('id') !== this.formId) return;

        // Seal may have (re)rendered with its default option after our delayed sync.
        window.clearTimeout(this.syncTimer);
        this.selectSealOption();
      }

      // Same mechanism as selectSealPurchaseType() in seal-subscription-custom.js.
      syncSeal() {
        window.clearTimeout(this.syncTimer);
        this.syncTimer = window.setTimeout(() => this.selectSealOption(), 250);
      }

      selectSealOption() {
        const form = this.getForm();
        const root = form && form.querySelector('.sealsubs-container') ? form : document;
        let sealInput = null;

        if (this.purchaseType === 'subscription' && this.sellingPlanId) {
          // Seal lists every plan group of the product (and may pre-check a disabled one):
          // pick the enabled group that holds this variant's selling plan.
          const planOption = root.querySelector(
            `.sealsubs-container .sls-option-container:not(.sls-disabled-option-container) option[value="${this.sellingPlanId}"]:not(:disabled)`
          );
          sealInput = planOption
            ? planOption.closest('.sls-option-container').querySelector('input.sls-option')
            : null;
        } else {
          sealInput = root.querySelector('.sealsubs-container input.sls-option[data-type="one_time"]');
        }

        if (sealInput && !sealInput.checked) sealInput.click();
      }
    }
  );
}
